// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickDateInput_dateInputContainer__cPknr {
  --foreground-color: var(--black);
  --background-color: var(--white);
  --border-radius: 0.25rem;
  --border-size: 2px;
  --focus-color: var(--blackAlpha);
  color: var(--foreground-color);
}
.ClickDateInput_dateInputContainer__cPknr.ClickDateInput_dark__6Bgb5 {
  --foreground-color: var(--white);
  --background-color: var(--black);
  --focus-color: var(--whiteAlpha);
}
.ClickDateInput_dateInputContainer__cPknr .ClickDateInput_dateInputWrapper__Fxzfj {
  display: inline-block;
}
.ClickDateInput_dateInputContainer__cPknr .ClickDateInput_dateInputWrapper__Fxzfj > .ClickDateInput_dateInput__\\+I1Z4 {
  border-radius: var(--border-radius);
  border: solid var(--border-size) var(--foreground-color);
  background: var(--white);
  color: var(--black);
  width: 100%;
  padding: 0.25em 0.5em;
}
.ClickDateInput_dateInputContainer__cPknr .ClickDateInput_dateInputWrapper__Fxzfj > .ClickDateInput_dateInput__\\+I1Z4::placeholder {
  color: var(--gray);
  font-style: italic;
}
.ClickDateInput_dateInputContainer__cPknr .ClickDateInput_dateInputWrapper__Fxzfj > .ClickDateInput_dateInput__\\+I1Z4:focus {
  outline: none;
  border-color: var(--blue);
}
.ClickDateInput_dateInputContainer__cPknr label {
  font-weight: var(--bold);
  display: block;
}
.ClickDateInput_dateInputContainer__cPknr .ClickDateInput_helpText__g3eA1 {
  display: block;
  font-size: 0.75em;
  padding-bottom: 0.25em;
}

.ClickDateInput_errorMessage__XrLkG {
  font-size: 0.75em;
  color: var(--danger);
  min-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/ClickDateInput.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,gCAAA;EACA,wBAAA;EACA,kBAAA;EACA,gCAAA;EAEA,8BAAA;AAAF;AAEE;EACE,gCAAA;EACA,gCAAA;EACA,gCAAA;AAAJ;AAEE;EACE,qBAAA;AAAJ;AACI;EACE,mCAAA;EACA,wDAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AACN;AAAM;EACE,kBAAA;EACA,kBAAA;AAER;AAAM;EACE,aAAA;EACA,yBAAA;AAER;AAGE;EACE,wBAAA;EACA,cAAA;AADJ;AAGE;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;AADJ;;AAIA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AADF","sourcesContent":[".dateInputContainer {\n  --foreground-color: var(--black);\n  --background-color: var(--white);\n  --border-radius: 0.25rem;\n  --border-size: 2px;\n  --focus-color: var(--blackAlpha);\n\n  color: var(--foreground-color);\n\n  &.dark {\n    --foreground-color: var(--white);\n    --background-color: var(--black);\n    --focus-color: var(--whiteAlpha);\n  }\n  .dateInputWrapper {\n    display: inline-block;\n    > .dateInput {\n      border-radius: var(--border-radius);\n      border: solid var(--border-size) var(--foreground-color);\n      background: var(--white);\n      color: var(--black);\n      width: 100%;\n      padding: 0.25em 0.5em;\n      &::placeholder {\n        color: var(--gray);\n        font-style: italic;\n      }\n      &:focus {\n        outline: none;\n        border-color: var(--blue);\n      }\n    }\n  }\n\n  label {\n    font-weight: var(--bold);\n    display: block;\n  }\n  .helpText {\n    display: block;\n    font-size: 0.75em;\n    padding-bottom: 0.25em;\n  }\n}\n.errorMessage {\n  font-size: 0.75em;\n  color: var(--danger);\n  min-height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dateInputContainer": `ClickDateInput_dateInputContainer__cPknr`,
	"dark": `ClickDateInput_dark__6Bgb5`,
	"dateInputWrapper": `ClickDateInput_dateInputWrapper__Fxzfj`,
	"dateInput": `ClickDateInput_dateInput__+I1Z4`,
	"helpText": `ClickDateInput_helpText__g3eA1`,
	"errorMessage": `ClickDateInput_errorMessage__XrLkG`
};
export default ___CSS_LOADER_EXPORT___;
